import Axios from "axios";
import flash from "../../../functions/flash";
import { setSpinner } from "../../../store/Store";
import { inviteUsers } from "../../endpoints";
import moment from "moment";

const invite = async (accessToken, users) => {
  try {
    setSpinner(true);
    await Axios.post(inviteUsers, { accessToken, users });
    flash("users has been invited to the admin portal", "success");
    setSpinner(false);
    return true;
  } catch (e) {
    const { data } = e.response || {};
    const { error } = data || {};
    const { code } = error || {};
    setSpinner(false);
    if (code === "auth/email-already-exists")
      flash(
        "One of your entered email addresses is already in use by another account",
        "danger"
      );
    else flash(e.message, "danger");
  }
};

export default invite;
